import api from './api';
import { User, UserList, UserForm, PasswordResetRequest, PasswordReset } from '../types';

export const usersService = {
  // Получение списка пользователей
  async getUsers(search?: string): Promise<UserList[]> {
    const params = search ? { search } : {};
    const response = await api.get('/api/users', { params });
    return response.data;
  },

  // Получение пользователя по ID
  async getUser(id: number): Promise<User> {
    const response = await api.get(`/api/users/${id}`);
    return response.data;
  },

  // Создание пользователя
  async createUser(userData: UserForm): Promise<User> {
    const response = await api.post('/api/users', userData);
    return response.data;
  },

  // Обновление пользователя
  async updateUser(id: number, userData: Partial<UserForm>): Promise<User> {
    const response = await api.put(`/api/users/${id}`, userData);
    return response.data;
  },


  // Получение компаний пользователя
  async getUserCompanies(id: number): Promise<{ companies: Array<{ id: number; name: string; country: string }> }> {
    const response = await api.get(`/api/users/${id}/companies`);
    return response.data;
  },

  // Сброс пароля пользователя
  async resetUserPassword(id: number): Promise<{ message: string }> {
    const response = await api.post(`/api/users/${id}/reset-password`);
    return response.data;
  },

  // Установка нового пароля пользователя (администратором)
  async setUserPassword(id: number, password: string): Promise<{ message: string }> {
    const response = await api.put(`/api/users/${id}/password`, { password });
    return response.data;
  },

  // Запрос сброса пароля по email
  async requestPasswordReset(email: string): Promise<{ message: string }> {
    const response = await api.post('/api/auth/reset-password', { email });
    return response.data;
  },

  // Обновление пароля по токену
  async updatePassword(token: string, newPassword: string): Promise<{ message: string }> {
    const response = await api.post('/api/auth/update-password', {
      token,
      new_password: newPassword
    });
    return response.data;
  }
};



























